import { render, staticRenderFns } from "./voicedetail.vue?vue&type=template&id=39d63c34&scoped=true"
import script from "./voicedetail.vue?vue&type=script&lang=js"
export * from "./voicedetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d63c34",
  null
  
)

export default component.exports